import React, { use, useEffect, useState } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import dummy from '../../Assets/Images/dummy.jpg.webp'
import { BsBookmarkHeart, BsBookmarkHeartFill } from "react-icons/bs"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import { setAlert } from "../../Store/Theme/actions"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { setCountApi } from "../../Store/Auth/actions"

const WishListPage = () => {

    const [loading, setLoading] = useState(true)
    const [profileList, setProfileList] = useState([])
    const [allStars, setAllStars] = useState([])
    const [educationList, setEducationList] = useState([]);
    const [zodiacSigns, setZodiacSigns] = useState([])
    const [flaws, setFlaws] = useState([])
    const [fullEducations, setFullEducations] = useState([])
    const [status, setStatus] = useState([])
    const [occupation, setOccupation] = useState([])
    const [planActive, setPlanActive] = useState(false)
    const dispatch = useDispatch()
    const userDetails = useSelector((state) => state.auth.userDetails)
    const lang = useSelector((state)=>state.theme.language)
    const {t} = useTranslation()
    const history = useHistory()
    const countApi = useSelector((state) => state.auth.countApi)
    const [count,setCount] = useState(0)

    useEffect(() => {
        try {
            setLoading(true)
            axios.all([API.get('/user/wishListProfile'),
            API.get('/common/getEducations'), API.get('/common/getZodiacSign'),
            API.get('/common/getAllFlaws'), API.get('/common/getStatusList'),
            API.get('/common/getOccupations'), API.get('/common/getAllStars')]).then(axios.spread((userRes, eduRes, zodiacRes, flawRes, statRes, occuRes, starRes) => {
                let responseValues = userRes.data.data.map((c)=>{
                    return {
                        ...c,
                        isWishlisted: true
                    }
                })
                setProfileList(responseValues)
                setPlanActive(userDetails.planActive)
                setEducationList(eduRes.data.data.map((c) => { return { text: `${c.education} ${c.specialization !== null ? `- ${c.specialization}` : ''}`, value: c._id } }))
                setFullEducations(eduRes.data.data)
                setZodiacSigns(zodiacRes.data.data.map((c) => { return { text: `${c.zodiacSign}`, value: c._id } }))
                setFlaws(flawRes.data.data.map((c) => { return { text: c.flawName, value: c._id } }))
                setStatus(statRes.data.data.map((c) => { return { text: c.status, value: c._id } }))
                setOccupation(occuRes.data.data)
                setAllStars(starRes.data.data.map((c) => { return { text: c.star, value: c._id } }))
                setLoading(false)
            }))
        } catch (err) {
            console.log(err)
        }
    }, [userDetails,count])

    const calculateAge = (birthdate) => {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        // If birth month is after current month or same month but birth date is after current date, subtract 1
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };

    const getFlaws = (value) => {
        return flaws.filter((x) => x.value === value)[0].text
    }

    const getQualification = (value) => {
        return educationList.filter((x) => { return x.value === value })[0].text
    }

    const profileShortlist = (value) => {
        let apiValues = {
            profileId: value._id,
            addedBy: userDetails._id
        }
        API.post('/user/bookmarkUser', apiValues).then((wishRes) => {
            if (wishRes.status === 200) {
                dispatch(setAlert({ title: 'Success', subtitle: 'Action successfull', type: 'success', active: true }))
                setProfileList(profileList.map((c) => {
                    if (c._id === wishRes.data.data.profileId) {
                        c.isWishlisted = !c.isWishlisted
                    }
                    return c
                }))
                setCount(count + 1)
                dispatch(setCountApi(countApi + 1))
            }
        })
    }
    return (
        <motion.div className="w-full overflow-scroll h-full py-5 flex flex-col bg-primeColor/20 gap-2">
            {
                loading ? "Loading please wait..." : <motion.div className="flex flex-col overflow-auto gap-2 px-2 sm:px-4 md:px-6">
                        {
                            profileList && profileList.length > 0 && profileList.map((c, i) => (
                                <motion.div
                                    key={i}
                                    className="flex flex-col rounded-lg bg-white gap-5 p-4 shadow-sm"
                                // Add padding and shadow for better UI on all screens
                                >
                                    <motion.div className="flex flex-col gap-5">
                                        <motion.div
                                            className="flex flex-col sm:flex-row justify-start gap-5"
                                        // On small screens stack vertically, from sm breakpoint go horizontal
                                        >
                                            <motion.div className="flex flex-col gap-2 relative w-[150px] md:w-[244px]">
                                                {/* width 100% on mobile, fixed width on sm+ */}
                                                {(c?.previewUrls && c.previewUrls[0]) ? (
                                                    <img
                                                        src={(planActive || c.isDownloaded) ? c.previewUrls[0] : dummy}
                                                        className="w-full h-[150px] md:h-[244px] object-center rounded-md"
                                                        alt="Preview"
                                                    />
                                                ) : (
                                                    <img
                                                        src={dummy}
                                                        className="w-full h-[150px] md:h-[244px] object-center rounded-md"
                                                        alt="Preview"
                                                    />
                                                )}
                                            </motion.div>
                                            <motion.div className="flex flex-col w-full relative gap-1">
                                                {lang === 'en' && (
                                                    <p
                                                        className="text-xl hover:underline cursor-pointer font-bold text-primeColor"
                                                        onClick={() => planActive ? history.push(`/fullProfile/${c._id}`) : history.push('/subscription')}
                                                    >
                                                        {c.firstName} ({c.surname})
                                                    </p>
                                                )}
                                                {lang === 'ta' && (
                                                    <p
                                                        className="text-xl hover:underline cursor-pointer font-bold text-primeColor"
                                                        onClick={() => planActive ? history.push(`/fullProfile/${c._id}`) : history.push('/subscription')}
                                                    >
                                                        {c.tFirstName} ({c.tSurname})
                                                    </p>
                                                )}
                                                <p className="text-[gray] text-md font-bold">{c.refId}</p>
                                                <motion.div className="flex flex-wrap items-center gap-2 text-sm sm:text-base">
                                                    {/* flex-wrap so items break nicely on small screens */}
                                                    <p>{calculateAge(c.dateOfBirth)} {t('Yrs')}</p>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGray]" />
                                                    <p>{c.heightInFeet || '-'}</p>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGray]" />
                                                    <span className="font-bold">{planActive || c.isDownloaded ? zodiacSigns.find(x => x.value === c.additionalInformation.zodiacSign)?.text : '----'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGray]" />
                                                    <span className="font-bold">{planActive || c.isDownloaded ? allStars.find(x => x.value === c.additionalInformation.star)?.text || '---' : '----'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGray]" />
                                                    <span className="font-bold">{c.otherEducationalQualification || '--'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGray]" />
                                                    {(planActive || c.isDownloaded)
                                                        ? (c.occupation !== 'undefined' && c.occupation.toString().trim().length ? c.occupation : 'Not working')
                                                        : '----'}
                                                </motion.div>
                                                <motion.div className="flex flex-col md:flex-row flex-wrap sm:flex-nowrap gap-2 mt-4 sm:absolute sm:bottom-0 w-full">
                                                    <motion.div
                                                        className="flex-1 sm:w-40 flex flex-row border border-primeColor bg-primeColor/30 text-black font-bold cursor-pointer justify-center items-center rounded-full px-2 py-2"
                                                        onClick={() => profileShortlist(c)}
                                                    >
                                                        {console.log(c.isWishlisted)}
                                                        {c.isWishlisted ? <BsBookmarkHeartFill size={14} /> : <BsBookmarkHeart size={14} />}&nbsp;&nbsp;  <p className="text-md">{c.isWishlisted ? t('Shortlisted') : t('Shortlist')}</p>
                                                    </motion.div>
                                                </motion.div>
                                            </motion.div>
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                            ))
                        }
                   
                </motion.div>
            }
        </motion.div >
    )
}

export default WishListPage